var pageLang = document.head.lang;
window.pageLang = document.head.lang;
var warnings = { "59565": { "1 июня": "warn" } };
var currentId = document.body.dataset.id;
var trip_id_relative = false;
var tripDate = null;
var trip_ids = [];

function setTimeOffset(date) {
    date = date || new Date();
    myTZO = -180;
    date = new Date(date);
    myNewDate = new Date(date.getTime() + (60000 * (date.getTimezoneOffset() - myTZO)));
    return myNewDate;
}


function convert(unixtimestamp) {
    var months_arr = (pageLang === 'ru') ? ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var date = new Date(unixtimestamp * 1000);
    var month = months_arr[date.getMonth()];
    var day = date.getDate();
    var convdataDay = day + ' ' + month;
    return convdataDay;
}


function convertToYyyyMmDd(unixtimestamp) {
    var months_arr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    var date = new Date(unixtimestamp * 1000);
    var year = date.getFullYear();
    var month = "0" + months_arr[date.getMonth()];
    var day = "0" + date.getDate();
    var convdataDay = year + '-' + month.substr(-2) + '-' + day.substr(-2);
    return convdataDay;
}


function generateNightWarning(time, date) {
    if (time && date) {
        var msg;
        var twentyFourHours = 86400;
        var hour = parseInt(time.trim().substr(0, 2));
        if (hour > 21) {
            msg = (pageLang === 'ru') ? ("Прогулка в ночь с " + convert(date) + " на " + convert(date + twentyFourHours)) : ("On the night from " + convert(date) + " to " + convert(date + twentyFourHours));
        } else if (hour < 4) {
            msg = msg = (pageLang === 'ru') ? ("Прогулка в ночь с " + convert(date - twentyFourHours) + " на " + convert(date)) : ("On the night from " + convert(date - twentyFourHours) + " to " + convert(date));
        } else {
            msg = "";
        }
        if (msg.length > 0) {
            $('#BuyNightTickets').html("<div class=remark style='font-weight: bold;padding-top: 5px;'>" + msg + "</div>");
        } else {
            $('#BuyNightTickets').html("");
        }
    }
}

function generateEventWarning(date) {
    var isId = warnings[currentId];
    if (typeof isId !== 'undefined') {
        var isWarning = isId[convert(date)];
        if (typeof isWarning !== 'undefined') {
            $('#EventWarning').html("<div class=remark style='font-weight: bold;padding-top: 5px;'>" + isWarning + "</div>");
        } else {
            $('#EventWarning').html("");
        }
    }
}

function addAZeroToASingleDigit(n) {
    return n < 10 ? '0' + n : n;
}

function formatDate(datetime){
    return addAZeroToASingleDigit(datetime.getDate()) + "." + addAZeroToASingleDigit(datetime.getMonth() + 1) + "." + datetime.getFullYear()
}

function strToDate(string){
    var parsed = string.split(".");
    var date = new Date();
    date.setFullYear(parsed[2]);
    date.setMonth(parseInt(parsed[1]) - 1);
    date.setDate(parsed[0]);

    return date
}

function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());
  
    const dates = [];
  
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
  
    return dates;
}

/**
 * Возвращает единицу времени в человекопонятном формате
 * @param seconds кол-во секунд
 * @return 
*/
function howLong(seconds){
    var out = "";
    var remain = 0;

    if(seconds >= 60 && seconds < 3600){
        number = Math.floor(seconds/60);
        remain = (seconds % 60);
        out = number + " " + plural(number, "минута", "минуты", "минут");
    } else if(seconds >= 3600 && seconds < 86400){
        number = Math.floor(seconds/3600);
        remain = (seconds % 3600);
        out = number + " " + plural(number, "час", "часа", "часов");
    } else if(seconds >= 86400){
        number = Math.floor(seconds/86400);
        remain = (seconds % 86400);
        out = number + " " + plural(number, "день", "дня", "дней");
    } else {
        out = seconds + " " + plural(seconds, "секунда", "секунды", "секунд");
    }

    if(remain > 60){
        out += " " + howLong(remain);
    }

    return out;
}

/**
 * Склонение численных
 * @param number склоняемое число
 * @param one количественная форма слова (день)
 * @param two (дня)
 * @param five (дней)
 * @return string
*/
function plural(number, one, two, five){
    
    if (number % 10 === 1 && number % 100 !== 11) {
        return one;
    } else if (number % 10 >= 2 && number % 10 <= 4 && ( number % 100 < 10 || number % 100 >= 20 )) {
        return two;
    } else {
        return five;
    }
}

var defaultTime = [];
var timeSelect = document.querySelector('[name="trip_time"]');
if (timeSelect) {
    var timeOptions = timeSelect.getElementsByTagName('option');
    for (var i = 0, len = timeOptions.length; i < len; i++) {
        defaultTime.push(timeOptions[i].value);
    }
}

var initTime = false;
var timerForSetDate;
var datepickerSettings = {
    format: 'dd.mm.yyyy',
    weekStart: 1,
    language: pageLang,
    keyboardNavigation: false,
    todayHighlight: false,
    autoclose: true,
    ignoreReadonly: true,
    defaultDate: new Date()
};
$('.input-group.date').datepicker(datepickerSettings);
$('#BuyFormTripDate').on('changeDate', function (e) {
    clearTimeout(timerForSetDate);

    var ts = e.date.getTime() - (new Date().getTimezoneOffset() * 60000);
    tripDate = ts / 1000;

    scheduleRequest(tripDate);
    generateEventWarning(setTimeOffset(new Date(tripDate * 1000).toString()).getTime() / 1000);
});

$("#BuyFormTripPoints").on("change", function (event){
    if(tripDate){
        scheduleRequest(tripDate);
    }
});

var dates_disabled = [];
var lastChangeDate = 0;

$('#BuyFormDateRange').on('changeDate', function (e) { // для отелей
    var dateStartElem = $("#BuyFormDate_from");
    var dateEndElem = $("#BuyFormDate_to");
    var dateStart = dateStartElem.datepicker("getDate");
    var seasonEnd = $('#BuyFormDateRange').attr("data-date-end-date");
    var seasonEndDate = null;

    if(e.target == dateStartElem[0]){
        dateEndElem.datepicker("clearDates");
        return;
    }

    try{
        seasonEndDate = strToDate(seasonEnd);
    } catch(e){
        seasonEndDate = null;
        console.error("seasonEnd invalid value");
    }

    var minDate = dateStart;
    //minDate.setDate(dateStart.getDate() + 1);

    dateEndElem.datepicker("setStartDate", minDate);
    if(dates_disabled.length > 0){
        var nextDisabledDate = null;

        var dates = getDatesInRange(dateStart, seasonEndDate);
        for(var i = 0; i < dates.length; i++){
            if(dates_disabled.includes(formatDate(dates[i]))){
                nextDisabledDate = dates[i];
                break;
            }
        }
        
        var date = dateStart;
        if(nextDisabledDate >= date){
            dateEndElem.datepicker("setEndDate", nextDisabledDate); // TODO: выбор этой даты в качестве конечной возможен, но не всегда
        } else {
            dateEndElem.datepicker("setEndDate", seasonEndDate);
        }
    } else {
        dateEndElem.datepicker("setEndDate", seasonEndDate);
    }
    
    //$("#dateUnavailableWarn").hide(); // пока нет нужды в этом сообщении
    var now = Math.ceil((new Date().getTime())/1000);
    if(now != lastChangeDate){ // потому что changeDate тригеррится много раз хз почему
        recalcSum();
        lastChangeDate = now;
    }
});

var calendar_data_range = $('#BuyFormDateRange');
if(calendar_data_range.length > 0){
    var preloader = $('<div class="holder" style="top: 3px; left: 3px;display:block;"><div class="preloader"><div></div><div></div></div></div>');
    $('#BuyFormDateRange').append(preloader);

    $('#BuyFormDateRange .js-form-control-calendar').attr("disabled", true);
    $.ajax({
        url: "/ajax/get_dates?id="+currentId,
    }).done(function (data){
        if(typeof data.unavailable != "undefined"){
            dates_disabled = data.unavailable;
            $('#BuyFormDateRange .js-form-control-calendar').datepicker("setDatesDisabled", data.unavailable);
            $('#BuyFormDateRange .js-form-control-calendar').attr("disabled", false);
            $('#BuyFormDateRange .js-form-control-calendar').datepicker("setStartDate", data.from);
            $('#BuyFormDateRange .js-form-control-calendar').datepicker("setEndDate", data.to);
        }
        preloader.remove();
    });
}

$(".readonly").on('keydown paste', function (e) {
    e.preventDefault();
});

(function (w) { // Полифил для URLSearchParams для IE
    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    }

})(window);

function generateTimeOption(time, item){
    var opt = document.createElement('option');

    var shipName = "";
    var availableSeatsValue = "";
    var time_str = time;

    if (pageLang === 'ru') {
        if (typeof item.shipName !== "undefined") {
            shipName = " - " + item.shipName; // Название теплохода. Есть не везде
        }

        if(time == "open"){
            time_str = "В течение дня";
        }
        if(item.places_left != null){
            if (item.places_left) {
                availableSeatsValue = ' (свободно ' + item.places_left + ' ' + plural(item.places_left, 'место', 'места', 'мест') + ')';
            } else {
                availableSeatsValue = ' (мест нет)';
            }
        }
        
    } else {
        if(time == "open"){
            time_str = "During the day";
        }
        if(item.places_left != null){
            if (item.places_left) {
                availableSeatsValue = item.places_left + " " + plural(item.places_left, 'seat', 'seats', 'setas') + " available";
            } else {
                availableSeatsValue = " (no seats available)";
            }
        }          
    }

    opt.innerHTML = time_str + shipName + availableSeatsValue;
    opt.value = item.hasPlaces ? time: '';
    opt.dataset.event = item.event_id;
    opt.disabled = !item.hasPlaces;

    return opt;
}

function updateTripIds() {
    var element = document.getElementById("program_id");
    if(!element){
        $("#BuyForm").append("<input id='program_id' name='api_trip_id[]' type=\"hidden\"/>");
    }

    element.value = trip_ids.length > 1 ? trip_ids.join(",") : trip_ids[0];

    // В ночь с .. на ..  при выборе времени 
    var date = $('#BuyFormTripDate').datepicker('getDate');
    generateNightWarning(timeSelect.value, date.getTime() / 1000);
}

var available_places = null;
var request = null;
function scheduleRequest(date) {

    var opentime_block = document.getElementById('nevatravel');
    if (opentime_block) {
        opentime_block.style.display = 'block';
    }

    if (document.getElementById('trip__time')) document.getElementById('trip__time').innerHTML = [];
    if (document.getElementById('trip__time_back')) document.getElementById('trip__time_back').innerHTML = [];
    if (document.getElementById('time-inline__start')) document.getElementById('time-inline__start').innerHTML = "... ";
    if (document.getElementById('time-inline__finish')) document.getElementById('time-inline__finish').innerHTML = "... ";

    $(".js-form-preloader").show();

    var native_pier = $("#BuyFormTripPoints option:selected").val();
    var source = $("#BuyForm").attr("source");
    var select__time = document.getElementById('trip__time');
    var return_piers__select = document.getElementById('return_piers__select');
    var combo_mode_elem = document.getElementById('combo_mode');
    var select__time_back_container = document.getElementById('backtrip');

    if (request != null) {
        request.abort(); // нужно для того, когда сервер отвечает долго прерать предыдущий запрос.
    }

    request = $.get('/ajax/gettimes', {
        date: convertToYyyyMmDd(date),
        pier_id: native_pier,
        trip_id: currentId,
        source: source
    }, function (response) {
        if (opentime_block) {
            opentime_block.disabled = false;
        }
        
        $(".js-form-preloader").hide();

        if (!response.error) {
            if (response.times) {

                trip_id_relative = response.trip_id_relative ?? false;

                var timesArr = Object.keys(response.times);
                var prices = {};
                var capacity = {};

                // для открытого времени первый и последний рейс
                if (document.getElementById('time-inline__start')) {
                    document.getElementById('time-inline__start').innerHTML = timesArr[0] ? timesArr[0] : '...';
                };
                if (document.getElementById('time-inline__finish')) {
                    document.getElementById('time-inline__finish').innerHTML = timesArr[timesArr.length - 1] ? timesArr[timesArr.length - 1] : '...';
                };

                select__time.innerHTML = '';

                var selectedItem = 0;

                var byuingSince = new Date();
                byuingSince.setHours(byuingSince.getHours() + 1);

                for (var i = 0; i < timesArr.length; i++) {
                    var time = timesArr[i];
                    var option = generateTimeOption(time, response.times[time]);
                    select__time.appendChild(option);

                    selectedItem = option.disabled ? i : selectedItem;

                    prices[time] = response.times[time].prices; 
                    
                    if(typeof response.times[time].places_left == "number"){
                        capacity[time] = response.times[time].places_left;
                    } else {
                        capacity[time] = Infinity;
                    } 
                }

                if (select__time.options[selectedItem]) {
                    select__time.options[selectedItem].selected = true;

                    select__time.onchange = function () {
                        if(trip_id_relative){
                            trip_ids[0] = select__time.options[select__time.options.selectedIndex].dataset.event;
                            updateTripIds();
                        }

                        // Показ актуальных цены
                        setPrices(prices[select__time.value]);
                        
                        recalcSum();
                        if(select__time.value == ""){
                            available_places = 0;
                        } else {
                            available_places = capacity[select__time.value];
                        }
                        checkCount();
                    };
                    select__time.onchange();
                } else {
                    select__time.innerHTML = '<option value="">На эту дату и направление нет прогулок</option>';
                    available_places = 0;
                }

                if(return_piers__select){
                    combo_mode_elem.onchange = function(){
                        if(combo_mode_elem.value == 1){
                            if(response.return_piers){
                                return_piers_container.style.display = "block";
                                select__time_back_container.style.display = "block";

                                return_piers__select.innerHTML = "";
                                return_piers__select.disabled = false;
                                
                                for(var i = 0; i < response.return_piers.length; i++){
                                    var pier = response.return_piers[i];
                                    var opt = document.createElement('option');
                                    opt.value = pier.id;
                                    opt.innerHTML = pier.name;
                                    return_piers__select.appendChild(opt);
                                }

                                return_piers__select.onchange = function(){
                                    requestReturnTimes(date, return_piers__select.value);
                                }
                                return_piers__select.onchange();
                            }
                        } else {
                            return_piers_container.style.display = "none";
                            select__time_back_container.style.display = "none";
                        }
                    }
                    combo_mode_elem.onchange();
                }
            } else {
                select__time.innerHTML = '<option value="">На эту дату и направление нет прогулок</option>';
                available_places = 0;
            }
        } else {
            select__time.innerHTML = '<option value="">Произошла ошибка, обратитесь в поддержку</option>';
            available_places = 0;
        }
        select__time.dispatchEvent(new Event('change'));
    }, 'json');
}

var request_back = null;
function requestReturnTimes(date, pier_id){
    var select__time_back = document.getElementById('trip__time_back');
    select__time_back.innerHTML = "";

    $("#backtrip > .js-form-preloader").show();

    if(request_back != null) { request_back.abort(); }
    
    request_back = $.get('/ajax/gettimes', {
        date: convertToYyyyMmDd(date),
        pier_id: pier_id,
        trip_id: currentId
    }, function (response) {
        if(response.times){
            var timesArr = Object.keys(response.times);
            for (var i = 0; i < timesArr.length; i++) {
                var time = timesArr[i];
                var option = generateTimeOption(time, response.times[time]);
                select__time_back.appendChild(option);
            }

            select__time_back.onchange = function (){
                var selectedIndex = select__time_back.selectedIndex;
                trip_ids[1] = select__time_back.options[selectedIndex].dataset.event;
                updateTripIds();
            }
            select__time_back.onchange();
        }
        $("#backtrip > .js-form-preloader").hide();
    }, 'json');
}

$('#time__select a').click(function (e) {
    e.preventDefault()
    $(this).tab('show');
}).on('show.bs.tab', function (e) {
    document.getElementById('time_fix').disabled = e.target.hash != '#time_fix';
});

$('[data-toggle="popover"]').popover();

function switchTickets(tag, show){
    if(show){
        $(".ticket_type_js[data-ticket-class=\"" + tag + "\"]").hide();
        $(".ticket_type_js:not([data-ticket-class=\"" + tag + "\"])").show();
    } else {
        $(".ticket_type_js[data-ticket-class=\"" + tag + "\"]").show();
        $(".ticket_type_js:not([data-ticket-class=\"" + tag + "\"])").hide();
    }
    $(".buy-form-ticket").val("0");
}

$(document).ready(function(){
    // переключатель 24/48ч
    $("#tickets_format_selector").on("change", function(e){
        switchTickets("48h", e.target.value == "48h");
        recalcSum();
    });
    $(".ticket_type_js[data-ticket-class=\"48h\"]").hide();

    // переключатель туда-обратно
    $("#combo_mode").on("change", function(e){
        switchTickets("combo", e.target.value == "0");
        recalcSum();
    });
    $(".ticket_type_js[data-ticket-class=\"combo\"]").hide();

    $(".group-incr .input-group-addon").children().css("pointer-events","none"); // Потому что при клике на иконку не срабатывает event
    $(".group-incr > .incr-plus, .group-incr > .incr-minus").on("click", function(e){
        var elem = $(e.target);
        var input = elem.parent().children("input.incr-input");
        var value = parseFloat(input.val());

        var min_value = parseFloat(input.attr("min")) || 0;
        var max_value = parseFloat(input.attr("max")) || Infinity;

        var step = parseFloat(input.attr("step")) || 1;

        if(elem.hasClass("incr-minus")){
            if(value > min_value){
                value = value - step;
            }
        } else if(elem.hasClass("incr-plus")) {
            if(value < max_value){
                value = value + step;
            }
        }

        input.val(value.toFixed(2));

        input.trigger("change");
    });
    
    // Выбор продолжительности поездки
    $(".duration-selector > input").on("change", function(e){
        updateTripDuration(e.target.value);
        recalcSum();
    });

    $("input[name=\"paymentType\"]").on("change", function(e){
        recalcSum();
    });
    updateTripDuration($(".duration-selector > input").val());
});

function updateTripDuration(hours){
    var hours = parseFloat(hours);
    // price_multiplier = hours; Не понятно зачем он тут нужен
    $(".duration-selector > .duration-label").text(howLong(hours * 3600));
}